// Favourite Live TV channels, persisted per browser (localStorage).
// Keys are stable channel keys ("in:chXXX"); the stored snapshot of name/logo
// lets the Favourites tab render instantly without fetching playlists.
const KEY = "poku.livetv.favorites.v1";

function read() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || "{}");
    return raw && typeof raw === "object" ? raw : {};
  } catch {
    return {};
  }
}

function write(map) {
  try {
    localStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    /* storage full/blocked — favourites just won't persist */
  }
}

export function getFavorites() {
  return read();
}

export function isFavorite(key) {
  return Boolean(read()[key]);
}

export function toggleFavorite(key, meta = {}) {
  const map = read();
  if (map[key]) {
    delete map[key];
  } else {
    map[key] = { name: meta.name || key, logo: meta.logo || null, group: meta.group || "", at: Date.now() };
  }
  write(map);
  return Boolean(map[key]);
}

export function favoriteCount() {
  return Object.keys(read()).length;
}
